import React from "react";
import { Box, Typography } from "@mui/material";

const FFFIntroView = () => (
  <Box
    sx={{
      minHeight: "100vh",
      bgcolor: "#050a14",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      p: { xs: 3, sm: 4 },
      position: "relative",
      overflow: "hidden",
      textAlign: "center",
      "@keyframes fffFadeUp": {
        from: { opacity: 0, transform: "translateY(18px)" },
        to: { opacity: 1, transform: "translateY(0)" },
      },
      "@keyframes fffEyesPulse": {
        "0%, 100%": { opacity: 1, textShadow: "0 0 18px rgba(255,215,0,0.45)" },
        "50%": { opacity: 0.55, textShadow: "0 0 42px rgba(255,215,0,0.9)" },
      },
    }}
  >
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "85%",
        height: "70%",
        background:
          "radial-gradient(ellipse at center, rgba(41,182,246,0.16) 0%, transparent 62%)",
        pointerEvents: "none",
      }}
    />
    <Typography
      sx={{
        color: "#29b6f6",
        fontWeight: 800,
        letterSpacing: { xs: 2, sm: 6 },
        fontSize: { xs: "0.75rem", sm: "0.9rem" },
        mb: 1.5,
        animation: "fffFadeUp 0.7s ease both",
      }}
    >
      WHO WANTS TO BEER MILLIONAIRE?
    </Typography>
    <Typography
      variant="h2"
      sx={{
        color: "#ffd700",
        fontWeight: 800,
        lineHeight: 1.05,
        fontSize: { xs: "2.1rem", sm: "3.4rem", md: "4rem" },
        textShadow: "0 0 36px rgba(255,215,0,0.45)",
        mb: 2.5,
        animation: "fffFadeUp 0.8s ease 0.15s both",
      }}
    >
      Fastest Finger First
    </Typography>
    <Typography
      sx={{
        color: "#fff",
        fontSize: { xs: "1.05rem", sm: "1.35rem" },
        fontWeight: 600,
        maxWidth: 560,
        mb: 0.8,
        animation: "fffFadeUp 0.8s ease 0.45s both",
      }}
    >
      Get into the hot seat.
    </Typography>
    <Typography
      sx={{
        color: "#4fc3f7",
        fontSize: { xs: "0.95rem", sm: "1.15rem" },
        maxWidth: 560,
        mb: 4,
        animation: "fffFadeUp 0.8s ease 0.65s both",
      }}
    >
      Answer the question fastest.
    </Typography>
    <Box
      sx={{
        width: 72,
        height: 2,
        bgcolor: "#ffd700",
        mb: 3.5,
        opacity: 0.7,
        animation: "fffFadeUp 0.6s ease 0.85s both",
      }}
    />
    <Typography
      sx={{
        color: "#ffd700",
        fontWeight: 800,
        letterSpacing: { xs: 6, sm: 10 },
        fontSize: { xs: "1.6rem", sm: "2.2rem" },
        animation: "fffFadeUp 0.6s ease 1.05s both, fffEyesPulse 1.6s ease 1.6s infinite",
      }}
    >
      EYES DOWN
    </Typography>
  </Box>
);

export default FFFIntroView;
